var nb = require('../../nb');
var util = require('../../util');
var wishItem = require('../../view/header/WishMenu').wishItem;
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        wishList:nb.model.List
    },
    method:{
        init:function () {
            this.set('wishList',{
                itemType:wishItem
            });
            this.onChange('list',function (inEvent) {
                var wishListModel  =this.get('wishList');
                var list = inEvent.data;
                if(list && list.length !==0){
                    this.set('status','have');
                    $.each(list,function (inIndex,inItem) {
                        var imageUrl = inItem.imageUrl;
                        inItem.imageUrl = imageUrl +"?x-image-process=image/resize,m_pad,h_500,w_500,color_FFFFFF";
                        inItem.detailHref = "detail.html?id="+inItem.spuId+'skuId'+inItem.skuId;
                        inItem.finishTime = util.formatDate(inItem.favTime);
                    });
                    this.set('wishList',{
                        items:list
                    });
                }else {
                    wishListModel.set('items','');
                    this.set('status','');
                }
            },this)
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/model/header/WishMenu.js
// module id = 37
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32